module.exports = __webpack_public_path__ + "static/media/bg2.1397a479.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg2.png
// module id = 231
// module chunks = 0